import React, { useCallback, useContext, useState } from 'react'
import styled from 'styled-components'
import CruiseWhenHowLong from './CruiseWhenHowLong'
import CruiseWhenMonth from './CruiseWhenMonth'
import { GlobalSearchDispatchContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import { GlobalSearchStateActions } from 'contexts/GlobalSearch/GlobalSearchState'
import noop from 'lib/noop'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { ButtonToggleItem } from 'components/Common/ButtonGroupToggle/ButtonGroupToggleItem'
import ButtonGroupToggle from 'components/Common/ButtonGroupToggle'
import { rem } from 'polished'
import Group from 'components/utils/Group'

const CruiseWhenListWrapper = styled(Group)`
  padding: ${rem(16)} 0;
  ${mediaQueryUp.sm} {
    max-height: 55vh;
    overflow-y: auto;
  }
`

const TabGroupToggle = styled(ButtonGroupToggle)`
  width: 100%;

  ${mediaQueryUp.sm} {
    width: ${rem(340)};
  }
`

const TabButtons: Array<ButtonToggleItem> = [
  { id: 'departure-month', label: 'Departure month' },
  { id: 'anytime', label: 'Anytime' },
]

interface Props {
  className?: string;
  onSelect?: () => void;
  onChange?: (value: App.CruiseGlobalFilters) => void;
  onClose?: () => void;
}

function CruiseWhenSerchList(props: Props) {
  const { className, onSelect = noop, onClose = noop, onChange = noop } = props
  const [tab, setTab] = useState<ButtonToggleItem>(TabButtons[0])
  const searchDispatch = useContext(GlobalSearchDispatchContext)

  const onTabSelect = useCallback((nextTab: ButtonToggleItem) => {
    if (nextTab.id === 'anytime') {
      searchDispatch({ type: GlobalSearchStateActions.SET_DURATION_RANGE, min: undefined, max: undefined })
      searchDispatch({ type: GlobalSearchStateActions.SET_FLEXIBLE_MONTH_RANGE, flexibleMonths: '' })
      onSelect()
      onClose()
    }
    setTab(nextTab)
  }, [onClose, onSelect, searchDispatch])

  return <CruiseWhenListWrapper
    direction="vertical"
    horizontalAlign="center"
    gap={20}
    className={className}
  >
    <TabGroupToggle
      items={TabButtons}
      activeItem={tab}
      onItemClick={onTabSelect}
    />
    {tab.id === 'departure-month' &&
      <>
        <CruiseWhenHowLong onSelect={onSelect} onChange={onChange} />
        <CruiseWhenMonth onSelect={onSelect} onChange={onChange} />
      </>
    }
  </CruiseWhenListWrapper>
}

export default CruiseWhenSerchList
